import RentFlowsIndex from '../laisTenantsRentFlows/pages/RentFlowsIndex.vue';
import { laisPath } from '../laisRouteHelpers';

const documentationRoute = {
  path: laisPath('/documentacao'),
  component: RentFlowsIndex,
  meta: { referenceAuthenticated: true },
};

export default documentationRoute;
